import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { BehaviorSubject } from 'rxjs';
import { CompanyServicesService } from 'src/app/features/companies/services/company-services/company-services.service';
import { AyenServices } from 'src/app/core/services/ayen-services/ayen-services.service';
import { DynamicServices } from 'src/app/features/ayen-services/services/dynamic-services/dynamic-services.service';
import { InspectorsService } from 'src/app/core/services/inspectors/inspectors.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { ProjectsService } from '../../services/projects.service';
import { ReProjectsService } from 'src/app/features/re-projects/services/re-projects.service';
import { take } from 'rxjs/operators';
import { CustomValidators } from 'src/app/shared/global/summernote-validator';
import * as moment from 'moment';
@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.scss'],
})
export class ProjectDetailsComponent implements OnInit {
  title: string = 'إضافة مشروع';
  saveBtn: string = 'إضافة';
  projectFormGroup!: UntypedFormGroup;
  companies: any[] = [];
  companiesPageCount: any;
  companiesPage: number = 1;
  reProjects: any[] = [];
  reProjectsPageCount: any;
  reProjectsPage: number = 1;
  inspectors: any[] = [];
  servicePage: number = 1;
  @ViewChild('selectcomp') selectcomp!: NgSelectComponent;
  @ViewChild('selectreproject') selectreproject!: NgSelectComponent;
  companySearchInput!: string;
  reProjectSearchInput!: string;
  inspectorSearchInput: string = '';
  timeout: any = null;
  fileName: string = '';
  fileSizeErr: boolean = false;
  formData: any = new FormData();
  bannerFormData: any = new FormData();
  imageFormData: any = new FormData();
  routeParam: any;
  services: any[] = [];
  alertmsg: boolean = false;
  message!: string;
  projectID: any;
  initServices: number[] = [];
  initDynamicServices: any[] = [];
  initInspectors: number[] = [];
  backUrl: string = '/pages/projects/list';
  MAX_FILE_SIZE: number = 5000000;
  saveDialogRef!: MatDialogRef<AlertBoxComponent>;
  dynamicServicesItemsData = new BehaviorSubject({});
  serviceData = this.dynamicServicesItemsData.asObservable();
  inspectorsItemsData = new BehaviorSubject({});
  inspectorData = this.inspectorsItemsData.asObservable();
  page: any = 1;
  inspectorPage: any = 1;
  page_count: any = 20;
  inspector_page_count: any = 0;
  params: {} = {};
  contractAcquiringUnitUrl: any;
  searchInput: string = '';
  dynamicServicesArr: any[] = [];
  dynamicServiceselements: any[] = [];
  dynamicEvents: any[]=[];
  MAX_BANNER_SIZE = 2000000;
  bannerSizeErr = false;
  fileBannerName: string | null = null;
  fileProjectImageName: string | null = null;
  imageSizeErr = false;
  fileImageName: string | null = null;
  projectAssets = {
    image: '',
    banner: ''
  }

  filteredServices: any[] = [];
  timelineServices: any[] = [];
  projectData: any;
  projectStatusList: any[] = [];

  isFileMap: { [key: string]: boolean } = {
  project_banner: false,
  project_image: false,
  };

  constructor(
    private formBuilder: FormBuilder,
    private inspectorService: InspectorsService,
    private ayenServices: AyenServices,
    private inspectorsService: InspectorsService,
    private companyService: CompanyServicesService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dynamicServices: DynamicServices,
    private projectsService: ProjectsService,
    private reProjectsService: ReProjectsService
  ) {}
  
  get serviceTimelineArray(): FormArray {
  return this.projectFormGroup.get('service_timeline_data') as FormArray;
  }
  
  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    this.getCompanies();
    this.getREProjects();
    this.getServices();
    this.getDynamicServices();
    this.getInspectors();
    this.getProjectStatus();
    this.routeParam = this.activatedRoute.snapshot.params.id;
    if (this.routeParam != 'add') {
      this.title = 'عرض / تعديل العقد';
      this.saveBtn = 'حفظ';
      this.projectID = this.routeParam;
      this.getProjectByID();
    }
  }

  getProjectStatus() {
    this.projectsService.getProjectStatus().subscribe((data) => {
      this.projectStatusList = data
    });
  }

  createForm() {
    this.projectFormGroup = this.formBuilder.group({
      name: [null, Validators.required],
      company: [null, Validators.required],
      project: [null],
      shortcode: [null],
      active_date: [null, Validators.required],
      expiry_date: [null, Validators.required],
      contract_file: [null],
      inspectors: [null],
      description: [null, [CustomValidators.maxTextLengthValidator(1000)]],
      units_count: [0],
      services: [null, Validators.required],
      dynamic_services: [null],
      is_acquirable: [false],
      show_terms_conditions: [true],
      show_order_documents:[true],
      project_banner: [null],
      project_image: [null],
      service_timeline_data: this.formBuilder.array([]),
      project_status: [null, Validators.required],
    });
  }
 
  createFormControls() {
    return this.projectFormGroup.controls;
  }

  initServiceTimeline() {
    if (this.timelineServices.length != 0) {
      const arr = this.timelineServices.map(service =>
        this.formBuilder.group({
          service: [service.service],
          name: [service.service_name],
          expected_start_date: [ service.expected_start_date, Validators.required],
          expected_delivery_date: [ service.expected_delivery_date, Validators.required]
        })
      );
      const formArray = this.formBuilder.array(arr);
      this.projectFormGroup.setControl('service_timeline_data', formArray);
    } else {
      this.save(false);
      this.getProjectByID();
    }
  }

  getProjectByID() {
    this.projectsService.getProjectByID(this.projectID).subscribe(
      (data) => {
        this.projectData = data;
        this.initServices = data.services;
        this.filteredServices = this.services.filter(service => this.initServices.includes(service.pk));
        this.timelineServices = data.service_timelines;
        this.initInspectors = data.inspectors;
        this.initDynamicServices = data?.dynamic_services;
        this.fileName = data.contract_file
          ? this.sliceFileName(data.contract_file)
          : '';
        this.patchValues(data);
        this.projectAssets ={
          image: data.project_image,
          banner: data.project_banner
        }
        this.initServiceTimeline();

      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  patchValues(data: any) {
    this.updateDynamicService(data);
    this.updateInspectorsList(data);
    this.getCompanyByPk(data.company.pk);
    this.contractAcquiringUnitUrl = data.contract_acquiring_unit_url;
    this.projectFormGroup.patchValue({
      name: data.name,
      company: data.company.pk,
      project: data.project,
      project_status: data.project_status.id,
      shortcode: data.shortcode,
      active_date: moment(data.active_date),
      expiry_date: moment(data.expiry_date),
      contract_file: data.contract_file,
      inspectors: data.inspectors,
      description: data.description,
      units_count: data.units_count,
      services: data.services,
      is_acquirable: data.is_acquirable,
      show_terms_conditions: data.show_terms_conditions,
      show_order_documents: data.show_order_documents,
      dynamic_services: data.dynamic_services,
    });
  }

  updateDynamicService(data: any) {
    data.dynamic_services.forEach((element: any) => {
      this.dynamicServices.getServiceById(element).subscribe((serviceData) => {
        this.dynamicServicesArr = [...new Set(this.dynamicServicesArr)];
        if (
          !this.dynamicServicesArr.find((item) => item.id === serviceData.id)
        ) {
          this.dynamicServicesArr.push({
            id: serviceData.id,
            name: serviceData.name,
          });
        }
      });
    });
  }
  updateDynamicServices(event: any) {
    if (event.reset) {
      this.page = 1;
      this.searchInput = '';
    } else {
      this.page = event.page ? event.page : this.servicePage;
      this.searchInput = event?.searchInput;
    }
    this.getDynamicServices();
  }

  updateInspectorsList(data: any) {
    data.inspectors.forEach((element: any) => {
      this.inspectorService.getInspectorByID(element).subscribe((inspectorData) => {
        this.inspectors = [...new Set(this.inspectors)];
        if (
          !this.inspectors.find((item) => item.id === inspectorData.id)
        ) {
          this.inspectors.push({
            id: inspectorData.id,
            full_name: inspectorData.full_name,
          });
        }
      });
    });
  }

  getCompanyByPk(pk: number | string) {
    this.companyService.getCompanyDetails(pk).pipe(take(1)).subscribe((company) => {
      const companiesMap = new Map(this.companies.map((item) => [item.pk, item]));
      if (!companiesMap.has(company.pk)) {
        companiesMap.set(company.pk, {
          pk: company.pk,
          name_arabic: company.name_arabic,
        });
      }
      this.companies = Array.from(companiesMap.values());
      this.projectFormGroup.get('company')?.setValue(company.pk);
    });
  }

  getCompanies() {
    const params = { page: this.companiesPage };
    this.companyService.getCompaniesList(params).subscribe((data) => {
      this.companies.push(...data.results);
      this.companiesPageCount = data.pages_count;
    });
  }

  resetSearch() {
    this.companies = [];
    this.companiesPage = 1;
    this.getCompanies();
  }

  onScrollPagination() {
    if (this.companiesPage < this.companiesPageCount) {
      this.companiesPage++;
      this.getCompanies();
    }
  }

  getREProjects() {
    const params: any = { page: this.reProjectsPage, page_size: 20 };
    if (this.reProjectSearchInput) {
      params['query'] = this.reProjectSearchInput;
    }
    this.reProjectsService.getREProjects(params).subscribe((data) => {
      if (this.reProjectsPage === 1) {
        this.reProjects = data.data || [];
      } else {
        this.reProjects.push(...(data.data || []));
      }
      this.reProjectsPageCount = data.pages_count;
    });
  }

  resetREProjectSearch() {
    this.reProjects = [];
    this.reProjectsPage = 1;
    this.reProjectSearchInput = '';
    this.getREProjects();
  }

  onScrollREProjectPagination() {
    if (this.reProjectsPage < this.reProjectsPageCount) {
      this.reProjectsPage++;
      this.getREProjects();
    }
  }

  searchREProjectText() {
    this.reProjectSearchInput = this.selectreproject.searchTerm;
    this.reProjects = [];
    this.reProjectsPage = 1;
    clearTimeout(this.timeout);
    let that = this;
    that.timeout = setTimeout(() => {
      if (that.reProjectSearchInput != '') {
        that.getREProjects();
      } else {
        this.reProjectsPage = 1;
        that.getREProjects();
      }
    }, 600);
  }

  searchText() {
    this.companySearchInput = this.selectcomp.searchTerm;
    this.companies = [];
    clearTimeout(this.timeout);
    let that = this;
    that.timeout = setTimeout(() => {
      if (that.companySearchInput != '') {
        that.getCompanies();
      } else {
        this.companiesPage = 1;
        that.getCompanies();
      }
    }, 600);
  }

  sliceFileName(name: string) {
    return name.slice(name.lastIndexOf('/') + 1, name.indexOf('?'));
  }

  deleteFile() {
    this.fileName = '';
    this.projectFormGroup.get('contract_file')?.setValue(null);
  }

  handleFileInput(files: FileList) {
    this.fileSizeErr = false;
    this.fileName = files[0].name;
    const size = files[0].size;
    if (size < this.MAX_FILE_SIZE) {
      this.formData.append('contract_file', files[0], this.fileName);
    } else {
      this.fileSizeErr = true;
    }
  }

  getServices() {
    this.ayenServices.getAyenServices().subscribe(
      (data) => {
        this.services = data;
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  getDynamicServices() {
    let params: { [key: string]: any } = {
      page: this.page,
      is_active: true,
    };
    if (this.searchInput && this.searchInput.length > 0) {
      params['name'] = this.searchInput;
    }
    this.dynamicServices.getServices(params).subscribe((data) => {
        this.page_count = data.pages_count;
        let results = data.results;
        let ids = new Set(this.dynamicServicesArr.map((d: any) => d.id));
       this.dynamicServicesArr = [...this.dynamicServicesArr, ...results.filter((d: any) => !ids.has(d.id))];
        this.dynamicServicesItemsData.next(this.dynamicServicesArr);    
    });
  }

  setServices(event: any) {
    this.projectFormGroup.controls.services.patchValue([...event]);
  }

  onScrollOptions(event: any) {
    if (event && this.page < this.page_count) {
      this.page++;
      this.params = { page: this.page };
      this.getDynamicServices();
    }
  }
  onScrollInspectorOptions(event: any) {
    if (event && this.page < this.page_count) {
      this.page++;
      this.params = { page: this.page };
      this.getInspectors();
    }
  }

  setDynamicServices(event: any) {
    this.initDynamicServices = event;
    this.projectFormGroup.controls.dynamic_services.patchValue([...event]);
  }

  getInspectors() {
    let params: { [key: string]: any } = {
      page: this.page,
      page_size: 10
    };
    if (this.inspectorSearchInput && this.inspectorSearchInput.length > 0) {
      params['full_name'] = this.inspectorSearchInput;
    }
    this.inspectorsService.getAvailableInspectors(params).subscribe((data) => {
        this.page_count = data.pages_count;
        let results = data.results;
        let ids = new Set(this.inspectors.map((d: any) => d.id));
        this.inspectors = [...this.inspectors, ...results.filter((d: any) => !ids.has(d.id))];
        this.inspectorsItemsData.next(this.inspectors);    
    });
  }

  setInspectors(event: any) {
    this.initInspectors = event;
    this.projectFormGroup.controls.inspectors.patchValue([...event]);
  }

  updateInspectors(event: any) {
    if (event.reset) {
      this.page = 1;
      this.inspectorSearchInput = '';
    } else {
      this.page = event.page ? event.page : this.inspectorPage;
      this.inspectorSearchInput = event?.searchInput;
    }
    this.getInspectors();
  }

  goProjects() {
    this.router.navigateByUrl('/pages/projects/list');
  }

  updateFormWithFormatedDate(formControl: string) {
    if (this.projectFormGroup.get(formControl)?.value) {
      let dateValue = moment(this.projectFormGroup.get(formControl)?.value);
      let formatedDate = dateValue.format('YYYY-MM-DD');
      this.projectFormGroup?.get(formControl)?.setValue(formatedDate);
    }
  }

  save(showAlert:boolean, event?: any) {
    this.updateFormWithFormatedDate('active_date');
    this.updateFormWithFormatedDate('expiry_date');
    this.alertmsg = false;
    if (this.projectFormGroup.status == 'INVALID') {
      this.alertmsg = true;
      this.message =
        'هناك خطأ في خانة أو بعض الخانات يرجى التأكد من المعلومات المدخلة';
    } else {
      this.appendFormData();
      if (this.projectID) {
        this.updateProject(this.formData, event.buttonId, showAlert);
      } else {
        this.createProject(event.buttonId);
      }
    }
  }

  clearFormDataFields() {
    // Clear all form data except contract_file if it was already uploaded
    const existingFile = this.formData.get('contract_file');
    this.formData = new FormData();
    if (existingFile && this.fileName) {
      this.formData.append('contract_file', existingFile);
    }
  }

  appendFormData() {
    this.clearFormDataFields();
    for (const [key, value] of Object.entries(this.projectFormGroup.value)) {
      if (key != 'contract_file' && value != null) {
        if (
          key == 'inspectors' ||
          key == 'services' ||
          key == 'dynamic_services' ||
          key == 'service_timeline_data'
        ) {
          let values = this.projectFormGroup.get(key)?.value;
          values.forEach((val: any) => {
            if(typeof val === 'object' && val !== null) {
              val = JSON.stringify(val);
            }
            this.formData.append(key, val);
          });
        } else {
          this.formData.append(key, value);
        }
      }
    }
  }

  createProject(buttonId: number) {
    this.projectsService.createProject(this.formData, buttonId).subscribe(
      (data) => {
        const msg = `تم إضافة مشروع ( ${data.name}) بنجاح.`;
        const url = '/pages/projects/' + data.pk;
        this.showAlertBox(msg, true,url);
      },
      (error) => {
        try {
          this.handleError(error);
        } catch {}
      }
    );
  }

  updateProject(data: any, buttonId: number, showAlert?: boolean) {
    this.projectsService.updateProject(this.projectID, data, buttonId).subscribe(
      (data) => {
        const msg = `تم تعديل مشروع ( ${data.name}) بنجاح.`;
        this.resetFileName()
         this.projectAssets ={
          image: data.project_image,
          banner: data.project_banner
        }

        if(showAlert) {
        this.showAlertBox(msg, true);
        }
      },
      (error) => {
        try {
          this.handleError(error);
        } catch {}
      }
    );
  }

  showAlertBox(msg: string, imgStatue: boolean, url?: string) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: imgStatue,
        message: msg,
        backUrl: url,
        button: 'تم',
      },
    });
  }

  handleError(error: any) {
    this.alertmsg = true;
    const firstValue = Object.values(error.error)[0];
    this.message = (firstValue !== undefined && firstValue !== null) ? firstValue.toString() : '';
  }

  closeError() {
    this.alertmsg = false;
  }

  clientStatus(event: any) {
    this.projectFormGroup.get(event.labelEn)?.setValue(event.value);
  }

  goToOrders() {
    this.router.navigate(['/pages/projects/orders'], {
      queryParams: { contract: this.projectID },
    });
  }

  copyReportLink() {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.contractAcquiringUnitUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  saveTimeline(event?: any) {
    this.timelineServices = this.serviceTimelineArray.value;
    this.timelineServices.forEach(service => {
      if (service.expected_start_date) { 
        service.expected_start_date = moment(service.expected_start_date).format('YYYY-MM-DD');
      }

      if (service.expected_delivery_date) {
        service.expected_delivery_date = moment(service.expected_delivery_date).format('YYYY-MM-DD');
      }
    });
    this.projectFormGroup.get('service_timeline_data')?.setValue(this.timelineServices);
    let data = {...this.projectFormGroup.value};
    data.service_timelines = this.timelineServices;
    data.expiry_date = moment(data.expiry_date).format('YYYY-MM-DD');
    data.active_date = moment(data.active_date).format('YYYY-MM-DD');
    delete  data.contract_file;
    this.updateProject(data,event?.buttonId, true);
  }

  preventPickerOpen(event: Event) {
    event.stopPropagation(); 
    event.preventDefault();  
  }

  resetFileName() {
   this.isFileMap['project_banner'] = false;
   this.isFileMap['project_image'] = false;
  }

  fileNameChange(event: { field: string; file: File | null }) {
    this.isFileMap[event.field] = !!event.file;
  }
}
